/* eslint-disable i18next/no-literal-string */
import { FC } from 'react'
import NextHead from 'next/head'
import Script from 'next/script'
import { exponeaInitScript } from '@lib/exponea'

const ZENDESK_KEY = process.env.NEXT_PUBLIC_ZENDESK_KEY

const Head: FC = () => {
    return (
        <>
            <NextHead>
                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1, maximum-scale=1"
                />
                <link
                    rel="manifest"
                    href="/site.webmanifest"
                    key="site-manifest"
                />
            </NextHead>
            <Script
                async
                id="ze-snippet"
                src={`https://static.zdassets.com/ekr/snippet.js?key=${ZENDESK_KEY}`}
                // // eslint-disable-next-line i18next/no-literal-string
                // strategy="beforeInteractive"
            />
            <Script
                async
                id="exponeaInitScript"
                dangerouslySetInnerHTML={{
                    __html: `${exponeaInitScript}`
                }}
                // eslint-disable-next-line i18next/no-literal-string
                strategy="beforeInteractive"
            />
            <Script src="https://accounts.google.com/gsi/client" async defer />
            <Script
                id="mse-sdk"
                src="https://unpkg.com/@adobe/magento-storefront-events-sdk/dist/index.js"
                strategy="beforeInteractive"
            />
            <Script
                id="mse-collector"
                src="https://unpkg.com/@adobe/magento-storefront-event-collector/dist/index.js"
                strategy="beforeInteractive"
            />
        </>
    )
}

export default Head
